import { useTranslation } from 'react-i18next';
import { CampaignChart } from '@anytag/shared-molecules';
import { RenderDataWithFallback, TableSegment } from '@anytag/shared-atoms';
import { MarketplaceDetail, NewCampaignReportSummary } from '@anytag/graphql';
import { PostReportEmpty, PostReportTable, PostReportSegmentKeys } from '../../../PostReport';
import { useMarketplaceReportTableData } from './hooks';

export interface MarketplaceReportTableProps {
  marketplace: MarketplaceDetail;
  summaryData?: NewCampaignReportSummary;
}
export const MarketplaceReportTable = ({ marketplace, summaryData }: MarketplaceReportTableProps) => {
  const { t } = useTranslation();
  const { reportData, loading, segment, networkStatus, segmentStatus, handleSegmentChange } =
    useMarketplaceReportTableData({ marketplace });

  return (
    <RenderDataWithFallback
      hasNoData={!reportData}
      noDataNode={<PostReportEmpty />}
      loading={loading && networkStatus === 1}
    >
      {reportData ? (
        <>
          <CampaignChart data={reportData.chartData} />
          <TableSegment
            type="switch"
            className="report-table-segment"
            values={(Object.keys(segmentStatus) as PostReportSegmentKeys[]).filter((key) => segmentStatus[key])}
            onChange={handleSegmentChange}
            options={[
              {
                label: t('Total'),
                value: PostReportSegmentKeys.total,
                loading: segment.total?.loading
              },
              {
                label: t('General.Post'),
                value: PostReportSegmentKeys.post,
                loading: segment.post?.loading
              }
            ]}
          />
          <PostReportTable
            loading={loading}
            data={reportData}
            segment={segment}
            summaryData={summaryData}
            pagination={{ totalRecords: reportData.postCount }}
          />
        </>
      ) : null}
    </RenderDataWithFallback>
  );
};
